export default {"src":"/_next/static/media/tutor_business.bcdf36ad.svg","height":795,"width":1091};